import React from 'react';
import '../global';

// Constants
const DEFAULT_DATE = new Date( 0 );
const CURRENCY_FORMAT = { style: 'currency', currency: 'USD' };

// Helper functions
const normalizeInvoiceItem = ( invoice ) => ({
		year            : parseInt( invoice.invoice_year ),
		title           : invoice.invoice_type,
		balance         : 0,
		hasBalance      : false,
		date            : new Date( `${ invoice.year }-01-01` ),
		isInvoiceHistory: true,
		originalItem    : invoice,
		invoiceNum      : null
	}
);

const normalizeSubscriptionItem = ( item ) => ({
		year: item.Invoice_Date
		      ? new Date( item.Invoice_Date ).getFullYear()
		      : null,
		title: item.Product,
		balance: parseFloat( item.Total_Balance ) || 0,
		hasBalance: parseFloat( item.Total_Balance ) > 0,
		date: item.Invoice_Date ? new Date( item.Invoice_Date ) : DEFAULT_DATE,
		isInvoiceHistory: false,
		originalItem: item,
		invoiceNum: item.Invoice_Num || null
	}
);

const formatCurrency = ( amount ) => amount.toLocaleString( 'en-US', CURRENCY_FORMAT );

const InvoiceTitles = ( { titles } ) => (titles.length > 1 ? (
		<div className="invoice-titles-container">
			{ titles.map( ( title, index ) => (
				<div key={ index } className="invoice-title-item">
					{ title }
				</div>
			) ) }
		</div>
	) : (<div className="invoice-single-title">
			{ titles[ 0 ] }
		</div>
                                         )
);

const ActionButton = ( { item } ) => {
	if ( item.isInvoiceHistory ) {
		return (<a
				href={ item.originalItem.invoice_link }
				target="_blank"
				rel="noopener noreferrer"
				className="btn btn-primary btn-sm"
			>
				View <i className="fa fa-external-link"></i>
			</a>
		);
	}

	if ( item.invoiceNum ) {
		return (<a
				href={ `/my-account/subscription-invoice/${ item.invoiceNum }` }
				target="_blank"
				className={ `btn btn-primary btn-sm ${ item.balance > 0
				                                       ? 'btn-invoice-btn'
				                                       : 'btn-invoice-btn-no-balance' }` }
			>
				Download Invoice
			</a>
		);
	}

	return null;
};

export default function SubscriptionsAndDues() {
	const myAccountObj = getMyAccountObj();

	const getAllItems = React.useMemo( () => {
		// Normalize and combine both arrays
		const invoiceItems = (myAccountObj.invoice_history || []
		)
			.map( normalizeInvoiceItem );

		const subscriptionItems = (myAccountObj.subscriptions_and_dues || []
		)
			.map( normalizeSubscriptionItem );

		const allItems = [...invoiceItems, ...subscriptionItems];

		// Group items by invoice number
		const groupedItems = allItems.reduce( ( acc, item ) => {
			if ( item.isInvoiceHistory || !item.invoiceNum ) {
				acc.push( { ...item, items: [item] } );
				return acc;
			}

			const existingGroup = acc.find( group => !group.isInvoiceHistory && group.invoiceNum === item.invoiceNum );

			if ( existingGroup ) {
				existingGroup.items.push( item );
				existingGroup.balance = parseFloat( item.originalItem.Total_Balance ) || 0;
				existingGroup.hasBalance = existingGroup.balance > 0;
				existingGroup.titles = Array.from( new Set( [...existingGroup.items.map( i => i.originalItem.Product )] ) );
			} else {
				acc.push( {
					          ...item,
					          items     : [item],
					          titles    : [item.originalItem.Product],
					          balance   : parseFloat( item.originalItem.Total_Balance ) || 0,
					          hasBalance: parseFloat( item.originalItem.Total_Balance ) > 0
				          } );
			}
			return acc;
		}, [] );

		// Sort items: balance > 0 first, then by year descending
		return groupedItems.sort( ( a, b ) => {
			if ( a.hasBalance !== b.hasBalance ) {
				return b.hasBalance - a.hasBalance;
			}
			return b.year - a.year;
		} );
	}, [myAccountObj.invoice_history, myAccountObj.subscriptions_and_dues] );

	const sortedItems = getAllItems;

	return (<div id="user-membership-invoice">
			<table className="table table-striped">
				<thead>
				<tr>
					<th>Year</th>
					<th>Title</th>
					<th>Balance</th>
					<th>Action</th>
				</tr>
				</thead>
				<tbody>
				{ sortedItems.map( ( item, index ) => (
					<tr key={ `item-${ index }` }>
						<td>{ item.year }</td>
						<td>
							<InvoiceTitles
								titles={ item.titles || [item.title] }/>
						</td>
						<td>
							{ item.isInvoiceHistory
							  ? 'N/A'
							  : formatCurrency( item.balance ) }
						</td>
						<td>
							<ActionButton item={ item }/>
						</td>
					</tr>
				) ) }
				</tbody>
			</table>
		</div>
	);
}